export default __webpack_public_path__ + "static/media/feather-calendar.f06df3a1.svg";